import api from '../api';

const fetchIndicator = (params = {}) => {
  return api.get(`/indicators_benchmarking`, {
    params: {
      ...params,
    },
  });
};
const fetchBenchmark = (params = {}) => {
  if(params.environment === 'DAIRY_CATTLE') {
    return api.get(`/benchmarking_dairy/datagrid`, {
      params: {
        ...params,
      },
    });
  }
  return api.get(`/benchmarking/datagrid`, {
    params: {
      ...params,
    },
  });
};
const fetchLastUpdated = (params = {}) => {
  return api.get(`/log_benchmarking/last_update`, {
    params: {
      ...params,
    },
  });
};
const fetchstatusHarvest = (params = {}) => {
  return api.get(`/log_benchmarking/status`, {
    params: {
      ...params,
    },
  });
};

const fetchBenchmarkingPDF = (params = {}, responseType = '', headers = {}) => {
  if(params.environment === 'DAIRY_CATTLE') {
    return api.get(`/benchmarking_dairy/pdf`, {
      params: {
        ...params,
      },
      responseType: `${responseType}`,
      headers: {
        ...headers,
      },
    });
  }
  return api.get(`/benchmarking/pdf`, {
    params: {
      ...params,
    },
    responseType: `${responseType}`,
    headers: {
      ...headers,
    },
  });
};

const createUpdated = (body = {}) => {
  if(body.environment === 'DAIRY_CATTLE') {
    return api.post(`/benchmarking_dairy/update`, {
      ...body,
    });
  }

  return api.post(`/benchmarking/update`, {
      ...body,
  });
};
const saveData = (body) => {
  return api.post(`/benchmarking_dairy/batch`, body);
};

export {fetchIndicator, fetchBenchmark, fetchLastUpdated, createUpdated, saveData, fetchstatusHarvest, fetchBenchmarkingPDF};
